// Tenant-aware navigation utilities
export const getTenantBasePath = (tenantType) => {
  switch (tenantType) {
    case 'agency':
      return '/agency';
    case 'employer':
      return '/employer';
    default:
      return '/login';
  }
};

export const getTenantSpecificRoute = (tenantType, route) => {
  const basePath = getTenantBasePath(tenantType);
  
  // If it's the root route, return just the base path
  if (route === '/' || route === '') {
    return basePath;
  }
  
  // Remove leading slash if present
  const cleanRoute = route.startsWith('/') ? route.slice(1) : route;
  
  return `${basePath}/${cleanRoute}`;
};

export const isValidTenantRoute = (tenantType, pathname) => {
  const basePath = getTenantBasePath(tenantType);
  return pathname.startsWith(basePath);
};

// Route mappings for different tenants
export const TENANT_ROUTES = {
  agency: {
    dashboard: '/agency',
    ongoingAssignments: '/agency/ongoing-management',
    compliancePending: '/agency/compliance-pending',
    settings: '/agency/setting'
  },
  employer: {
    dashboard: '/employer',
    postJob: '/employer/post-job',
    jobManagement: '/employer/job-management',
    applications: '/employer/assignments',
    ongoingEngagements: '/employer/ongoing-management',
    settings: '/employer/setting',
    profile: '/employer/profile'
  }
};

export const getAvailableRoutes = (tenantType) => {
  return TENANT_ROUTES[tenantType] || {};
}; 